var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoticeErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0004 21.5984C17.3023 21.5984 21.6004 17.3004 21.6004 11.9984C21.6004 6.6965 17.3023 2.39844 12.0004 2.39844C6.69846 2.39844 2.40039 6.6965 2.40039 11.9984C2.40039 17.3004 6.69846 21.5984 12.0004 21.5984ZM10.4489 8.74991C9.98029 8.28128 9.22049 8.28128 8.75186 8.74991C8.28323 9.21854 8.28323 9.97834 8.75186 10.447L10.3033 11.9984L8.75186 13.5499C8.28323 14.0185 8.28323 14.7783 8.75186 15.247C9.22049 15.7156 9.98029 15.7156 10.4489 15.247L12.0004 13.6955L13.5519 15.247C14.0205 15.7156 14.7803 15.7156 15.2489 15.247C15.7175 14.7783 15.7175 14.0185 15.2489 13.5499L13.6974 11.9984L15.2489 10.447C15.7175 9.97834 15.7175 9.21854 15.2489 8.74991C14.7803 8.28128 14.0205 8.28128 13.5519 8.74991L12.0004 10.3014L10.4489 8.74991Z",
    fill: "#EF4444"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeErrorIcon);
export default __webpack_public_path__ + "static/media/NoticeErrorIcon.03f0d047f72f7dd8e5128ae8902bde30.svg";
export { ForwardRef as ReactComponent };